export function Sticky(element, topSpacing = 0, onState = (isStick) => {}) {
  if (!element.length) {
    return;
  }
  if (element.prop("sticky") === undefined) {
    getDataSticky(element);
    $(window).on('scroll', function () {
      Sticky(element, topSpacing);
    });
    $(window).on('resize', function () {
      removeSticky(element);
      getDataSticky(element);
      Sticky(element, topSpacing);
    });
  }
  if ($(window).scrollTop() >= element.prop("sticky") - topSpacing) {
    if ($('.just-for-height', element.parent()).length === 0) {
      element.after('<div class="just-for-height" style="height:' + element.outerHeight() + 'px; width:' + element.outerWidth() + 'px;"></div>')
    }
    element.css("left", element.prop("stickyLeft") + "px");
    element.css("margin-left", "unset");
    element.css("margin-right", "unset");
    element.css("width", element.prop("stickyWidth") + "px");
    element.css("top", topSpacing + "px");
    element.css("position", "fixed");
    // element.css("transition", "all 1s");
    element.addClass("sticky");
    onState(true);
  } else {
    removeSticky(element);
    onState(false);
  }
}

export function removeSticky(element) {
  if (!element.length) {
    return;
  }
  element.removeClass("sticky");
  element.css("top", "");
  element.css("left", "");
  element.css("width", "");
  element.css("position", "");
  element.css("margin-left", "");
  element.css("margin-right", "");
  // element.css("transition", "");
  $('.just-for-height', element.parent()).remove();
}

export function getDataSticky(element) {
  if (!element.length) {
    return;
  }
  element.prop("sticky", element.offset().top + 1);
  element.prop("stickyWidth", element.outerWidth());
  element.prop("stickyLeft", element.offset().left);
}